export default __webpack_public_path__ + "static/media/close-map-icon.c975d6a3.svg";